import ApiService from '../../../services/api.service';

export default class CompositionsServices {
    /* @ngInject */
    constructor(ApiService) {
        /**
         * @type ApiService
         */
        this.api = ApiService;
    }

    getAll(filters, sorts, pagination) {
        return this.api.get('massia/compositions', {
            params: {
                filters: JSON.stringify(filters || []),
                sorts: JSON.stringify(sorts || []),
                pagination: JSON.stringify(pagination || { skip: 0, take: 0 })
            }
        });
    }

    async updateListResVis(lstComposToModified, date = null) {
        const serviceUrl = 'massia/compositions/update';
        const url = `${serviceUrl}`;
        return this.api.put(url, lstComposToModified, date);
    }
}
